import {get,post} from './api';

const getClazzCourse = get('clazz-course/get');
const deleteClazzCourse = post('clazz-course/delete');

export {
    getClazzCourse,
    deleteClazzCourse,
}
